import React, { useMemo, useState } from 'react'
import { useWallet, Wallet } from '@txnlab/use-wallet-react'

const ConnectWallet: React.FC = () => {
  const { activeAddress, wallets, activeWallet } = useWallet()

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isCopied, setIsCopied] = useState<boolean>(false)

  const supportedWallets = useMemo(() => {
    const order = ['pera', 'defly', 'lute']
    const map: Record<string, Wallet | undefined> = {}
    for (const w of wallets || []) {
      map[w.metadata.name.toLowerCase()] = w
    }
    return order.map((id) => map[id]).filter(Boolean) as Wallet[]
  }, [wallets])

  const truncateAddress = (address: string) => {
    if (!address) return ''
    return `${address.slice(0, 6)}...${address.slice(-4)}`
  }

  const connectWith = async (wallet: Wallet) => {
    try {
      await wallet.connect()
      setIsMenuOpen(false)
    } catch (_e) {}
  }

  const handleMainClick = () => {
    setIsMenuOpen((v) => !v)
    setIsCopied(false)
  }

  const copyToClipboard = async () => {
    if (!activeAddress) return
    try {
      await navigator.clipboard.writeText(activeAddress)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 1200)
    } catch (_e) {
      setIsCopied(false)
    }
  }

  const disconnect = async () => {
    try {
      await activeWallet?.disconnect()
    } finally {
      setIsMenuOpen(false)
    }
  }

  const openDonation = () => {
    setIsMenuOpen(false)
    window.dispatchEvent(new Event('algofaucet:donation:open'))
  }

  return (
    <div className="wallet-wrap">
      <button
        data-test-id="connect-wallet"
        className="px-btn wallet-trigger"
        onClick={handleMainClick}
        type="button"
      >
        {activeAddress ? truncateAddress(activeAddress) : 'CONNECT'}
      </button>

      {isMenuOpen && !activeAddress && (
        <div className="wallet-menu wallet-menu-icons">
          {supportedWallets.map((w) => {
            const id = w.metadata.name.toLowerCase()
            const icon = id === 'pera' ? '/Pera.png' : id === 'defly' ? '/Defly.png' : '/Lute.png'
            return (
              <button
                key={w.metadata.name}
                onClick={() => connectWith(w)}
                className="px-btn px-btn-icon"
                type="button"
                aria-label={w.metadata.name}
              >
                <img src={icon} alt="" />
              </button>
            )
          })}
        </div>
      )}

      {isMenuOpen && activeAddress && (
        <div className="wallet-menu wallet-menu-icons">
          <button
            className="px-btn px-btn-icon"
            type="button"
            aria-label="Donate"
            onClick={openDonation}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 5V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <button
            onClick={copyToClipboard}
            className="px-btn px-btn-icon"
            type="button"
            aria-label={isCopied ? 'Copied' : 'Copy address'}
          >
            {isCopied ? (
              <span aria-hidden="true">✓</span>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="9" y="9" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
                <rect x="5" y="5" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
              </svg>
            )}
          </button>
          <button
            onClick={disconnect}
            className="px-btn px-btn-icon"
            type="button"
            aria-label="Disconnect"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M15 7L20 12L15 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M13 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      )}
    </div>
  )
}

export default ConnectWallet
